import { LinearProgress, linearProgressClasses, styled } from "@mui/material";
import React from "react";
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
    },
}));
const ProgressBar = ({ percentageCompleted }) => {
    return (React.createElement(BorderLinearProgress, { variant: "determinate", value: percentageCompleted }));
};
export default ProgressBar;
